import React from "react";
import Profile from "./Profile";

// Page displayed in url: https://varsome.com/phenotype/profile/@username
const ProfilePage = () => {
  return (
    <section className="no-vert-padding no-stretching">
      <Profile />
    </section>
  );
};

export default ProfilePage;
